/**
 * PWA Service Worker 등록.
 * - 캐시 용도로만 사용한다. 사용자에게 띄우는 알럿은 buildVersionCheck(localStorage)가 담당한다.
 * - 새 SW를 즉시 활성화(SKIP_WAITING)시켜 다음 진입에 새 precache가 적용되도록 한다.
 * - dev/qa는 MSW가 SW 슬롯을 차지하므로 호출하지 않는다.
 */

const isMSWController = () => {
  if (!('serviceWorker' in navigator)) return false;
  const controller = navigator.serviceWorker.controller;
  return Boolean(controller && controller.scriptURL.includes('mockServiceWorker'));
};

export const invokeServiceWorkerUpdateFlow = (registration) => {
  if (isMSWController()) return;

  registration.waiting.postMessage('SKIP_WAITING');
};

const addUpdateFoundEventListener = (registration) => {
  if (isMSWController()) return;

  registration.addEventListener('updatefound', () => {
    console.log('새로운 업데이트가 발견되었습니다');

    registration.installing.addEventListener('statechange', () => {
      if (!registration.waiting) {
        return;
      }

      if (navigator.serviceWorker.controller) {
        invokeServiceWorkerUpdateFlow(registration);
      } else {
        console.log('서비스 워커 최초 초기화...');
      }
    });
  });
};

export const registerSW = () => {
  if (!('serviceWorker' in navigator)) {
    return;
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('서비스 워커 등록:', registration);
        addUpdateFoundEventListener(registration);
      })
      .catch((registrationError) => {
        console.log('서비스 워커 등록 실패:', registrationError);
      });
  });
};
